import type { MouseEventHandler } from 'react';
import styled, { css } from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import type { MediaImageProps } from '@elfsight/widget-media';
import { MediaImage } from '@elfsight/widget-media';
import { Loader } from '@elfsight/widget-ui';
import { MediaTypeIcon } from '../../MediaTypeIcon';

interface VideoDummyProps {
  src: string;
  mediaImageProps: MediaImageProps;
  mode: 'loading' | 'redirect';
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export function VideoDummy({
  src,
  mediaImageProps,
  mode,
  onClick
}: VideoDummyProps) {
  return (
    <VideoDummyContainer onClick={onClick}>
      <MediaImage src={src} {...mediaImageProps} ratio={0.66} />
      <Show when={mode === 'redirect'}>
        <VideoIcon type="video" />
      </Show>

      <Show when={mode === 'loading'}>
        <VideoLoader color="white" />
      </Show>
    </VideoDummyContainer>
  );
}

const VideoDummyContainer = styled.div`
  position: relative;
  width: 100%;
  cursor: pointer;
`;

const floatingMixin = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const VideoIcon = styled(MediaTypeIcon).attrs({
  size: 48,
  withoutTooltip: true
})`
  ${floatingMixin};
`;

const VideoLoader = styled(Loader)`
  ${floatingMixin};
`;
